"use client";
import { CommonProcutListWrapper } from "@/styles/product";
import Card from "./card";
import { JDIProductCardV2 } from "@/lib/jdiClientUtils";
import { AddCart } from '@/apis/service';
import { getUserUUIDFromCookie } from "@/utils/userUtils";
import UKToast from "@/components/UKToast";

type Props = {
    title?: string,
    data: any[],
    headerNav?: React.ReactNode
}

export default function CommonProductList ({title, data = [], headerNav = null}: Props) {

    const addCart = async (product: any) => {
        const cartuuid = getUserUUIDFromCookie();
        const res = await AddCart({ num: 1, skuId:product.skuId, cartuuid })
        if (res?.code === '200') {
          UKToast.show({
            content: "Added to Cart!", // 弹窗内容
            icon: "success", // 可选：success, fail, loading, warn, info，影响图标
          });
          (window as any).JDIheader.initCartNum()
        } else {
          UKToast.show({
            content: "Added to cart Failed please try again", // 弹窗内容
            icon: "error", // 可选：success, fail, loading, warn, info，影响图标
          });
        }
      };

    return <> {!!data?.length && <>
    {/* {headerNav} */}
    <CommonProcutListWrapper>
        { title && <p className="title">{title}</p>}
        <div className="product-card-wrapper">
            {/* { data.map((item: any, index: number)=> <Card key={index} data={item} />)} */}
            {data.map((item: any, index: number)=> {
              if(!item.content){
                return null
              }
                const productData = {
                    skuId: item.skuId,
                    skuImgKeyParams: {
                        imgUrlKey: item.content?.imageUrl,
                        width: 240,
                        height: 240,
                        domains: process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(","),
                      },
                    skuName: item.content?.wareName,
                    // imageUrl: item.content.imageUrl,
                    realPrice: item.content?.realPrice,
                    originalPrice: item.content?.originalPrice,
                    type: "2",
                    saleNum: item.content?.saleNum,
                    score: item.content?.commentScore,
                    shouldShowScore: true,
                    shouldShowCart: true,
                    onClickCart: addCart,
                    promotions: item.content?.promotions || []
                }
                // return <>{item.content.originalPrice}</>
                return <JDIProductCardV2 productData={productData} key={item.skuId} />
            })}
        </div>
    </CommonProcutListWrapper>
    </>}</>
}